import React from "react";

export default function Flex() {
  return <div className="flex-1" />;
}
